import { cn } from "@/utils/cnHelper";
import React from "react";

export type TitleProps = {
  children: React.ReactNode;
  as?: "h1" | "h2" | "h3";
  className?: string;
};

export default function Title({ children, as = "h3", className }: TitleProps) {
  const Tag = as as keyof JSX.IntrinsicElements;

  const classes = cn(
    "tw-font-semibold tw-tracking-tight tw-text-[var(--foreground-color)]",
    as === "h1" && "!tw-text-4xl sm:!tw-text-6xl lg:!tw-text-7xl tw-text-balance",
    as === "h2" && "!tw-text-3xl sm:!tw-text-4xl lg:!tw-text-5xl tw-text-pretty",
    as === "h3" && "!tw-text-2xl sm:!tw-text-3xl lg:!tw-text-4xl tw-text-pretty",
    className
  );
  return <Tag className={classes}>{children}</Tag>;
}
